export const TipoFechaServicio = [
    {
        nombreEnvio: "fechaAlta",
        nombreProceso: "FECHA DE ALTA"
    }, {
        nombreEnvio: "fechaBaja",
        nombreProceso: "FECHA DE BAJA"
    }, {
        nombreEnvio: "fechaIngresa",
        nombreProceso: "FECHA DE INGRESO"
    }];

export const nombreEnvio = (nombreProceso: string) => {
    return TipoFechaServicio.find(tipo => tipo.nombreProceso === nombreProceso);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/modelo/TipoFechaServicio.ts